import { CmsComponent, CmsComponentConnector, PageContext } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { Observable, of, zip } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

// TODO Remove when upgrading to Spartacus 5.0
@Injectable({
  providedIn: 'root'
})
export class CustomCmsComponentConnector extends CmsComponentConnector {
  getList(ids: string[], pageContext: PageContext): Observable<CmsComponent[]> {
    return this.cmsStructureConfigService.getComponentsFromConfig(ids).pipe(
      switchMap((configuredComponents) => {
        // check if we have some components that are not loaded from configuration
        const missingIds = configuredComponents.reduce((acc, component, index) => {
          if (component === undefined) {
            acc.push(ids[index]);
          }
          return acc;
        }, []);

        if (missingIds.length > 0) {
          const pageSize = 50;
          const totalPages = Math.ceil(missingIds.length / pageSize);
          const cmsComponents: Observable<CmsComponent[]>[] = [];

          let currentPage = 0;
          while (currentPage < totalPages) {
            cmsComponents.push(
              this.cmsComponentAdapter.findComponentsByIds(
                missingIds.slice(currentPage * pageSize, (currentPage + 1) * pageSize),
                pageContext
              )
            );
            currentPage++;
          }
          return zip(...cmsComponents).pipe(
            map((loadedComponents) => [...configuredComponents.filter(Boolean)].concat(...loadedComponents))
          );
        } else {
          return of(configuredComponents);
        }
      })
    );
  }
}
